export default "__VITE_ASSET__RmuvaAoS__"